// extracted by mini-css-extract-plugin
export var breadcrumb = "PartnerPageLayout-module__breadcrumb___EGzV7";
export var breadcrumbCurrent = "PartnerPageLayout-module__breadcrumbCurrent___4dC-q";
export var breadcrumbLink = "PartnerPageLayout-module__breadcrumbLink___iILIX";
export var breadcrumbSeparator = "PartnerPageLayout-module__breadcrumbSeparator___NP9Dz";
export var content = "PartnerPageLayout-module__content___7wx5D";
export var inner = "PartnerPageLayout-module__inner___fX-H2";
export var layout = "PartnerPageLayout-module__layout___IIdck";
export var wide = "PartnerPageLayout-module__wide___GExnZ";